export default "__VITE_ASSET__BcnxtV8k__"